import { Injectable } from "@angular/core";

import { Observable } from "rxjs";

import { BaseApiService } from "@app/shared/services/base-api.service";

import { Product, ProductDefinition } from "@shared/models";

@Injectable({
  providedIn: "root",
})
export class ProductDefinitionsApiService extends BaseApiService {
  protected readonly endpoint = "/config/productdefinitions";
  protected readonly microservice = "configServ" as const;

  /**
   * GET /api/config/productdefinitions/GetAllActiveProductMasterInfo
   */
  getActiveProducts(): Observable<Product[]> {
    return this.get<Product[]>("/GetAllActiveProductMasterInfo");
  }

  /**
   * GET /api/config/productdefinitions/by-productmaster-id/{productMasterId}
   */
  getProductDefinitionsByMasterId(
    productMasterId: number,
  ): Observable<ProductDefinition[]> {
    return this.get<ProductDefinition[]>(
      `/by-productmaster-id/${productMasterId}`,
    );
  }

  /**
   * GET /api/config/productdefinitions/get-products-by-order-type
   */
  getProductsByOrderType(
    orderType: string,
    productMasterId: number = 1,
  ): Observable<ProductDefinition[]> {
    const params = this.buildParams({
      orderType,
      productMasterId,
    });

    return this.get<ProductDefinition[]>("/get-products-by-order-type", {
      params,
    });
  }
}
